import gql from 'graphql-tag';
import ProductCategory from '../../../entity/productCategory';

const getProductCategories = gql`
  query productCategoriesByStore(
    $storeId: IDString!
    $searchInput: ProductCategorySearchInput
  ) {
    productCategoriesByStore(
      storeId: $storeId
      searchInput: $searchInput
    ) {
      edges {
        node {
          ${ProductCategory.fragmentsFields()}
        }
      }
    }
  }
`;

export default getProductCategories;
